export const task = {
  index: {
    title: 'Список задач'
  },

  field: {
    id: 'ID',
    number: 'Номер',
    caller_id: 'Caller ID',
    priority: 'Приоритет',
    attempts: 'Положение в стратегии',
    strategy: 'Положение в стратегии',
    start: 'Дата создания заказа',
    status: 'Статус',
    last_attempt: 'Последняя попытка',
    next_attempt: 'Следующая попытка',
    created_at: 'Дата создания заказа',
    lead_date: 'Дата создания задачи',
    delayed_until: 'Отложена до',
    additionally: 'Дополнительно'
  },

  state: {
    title: 'Статус',
    success: 'Успешно',
    processing: 'В процессе',
    canceled: 'Отменена',
    pending: 'В ожидании',
    fail: 'Неуспешно'
  },

  tooltips: {
    strategy:
      'От заданного значения будет зависеть с какого этапа стратегии будут происходить попытки дозвона.',
    caller_id:
      'Если поле оставить незаполненным, то задаче будет присвоен Caller ID заданный при создание кампании',
    delayed_until: 'Время указывается в UTC +00:00',
    additionally:
      'Поле представляет собой любую дополнительную информацию, которая будет передаваться в хук.'
  },

  warnings: {
    skills: 'Навыки операторов не будут учитываться. В настройках кампании не выбран пункт "Учитывать навыки операторов".'
  },

  button: {
    create: 'Создать задачу',
    disabled: 'Все вебхуки уже созданы'
  },

  modal: {
    create: 'Создание задачи',
    edit: 'Редактировать задачу',
    import: 'Импортировать задачи',
    import_hint:
      'Убедитесь, что номера в файле хранятся в международном формате. Например, +7ХХХХХХХХХХ.'
  }
};
